import axios from "axios";

// In production we prefer same-origin API calls through Nginx: /api -> backend.
// Set REACT_APP_BACKEND_URL only when the API is hosted on a separate origin.
const RAW_BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");
export const API = RAW_BACKEND_URL ? `${RAW_BACKEND_URL}/api` : "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 15000,
  headers: {
    "X-Requested-With": "RechoMusic-Web",
  },
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const detail = error?.response?.data?.detail;
    const message = Array.isArray(detail)
      ? detail.map((d) => d.msg).join(", ")
      : detail || error?.message || "Network error";

    error.userMessage = status === 429
      ? "Too many requests. Please slow down and try again."
      : status >= 500
        ? "Server is temporarily unavailable. Please try again."
        : message;
    return Promise.reject(error);
  }
);

export function getApiError(error, fallback = "Something went wrong") {
  return error?.userMessage || fallback;
}
